import React from 'react';
import Immutable from 'immutable';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { Node } from '@uncinc/react-drupal-core';

const ParagraphContactInformation = ({ entity }) => {

  const contactPersons = entity.getIn(['field_contact_person']);
  const partners = entity.getIn(['field_organisation']);
  const title = entity.getIn(['field_title', 0, 'value'], 'In samenwerking met de volgende betrokkenen');

  return (
    <Container className="Paragraph ParagraphContactInformation">
      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2">
          <div className="ParagraphContactInformation__Wrapper">

            <h3 className="ParagraphContactInformation__Title">{title}</h3>

            <div className="ParagraphContactInformation__ContactWrapper">

              {contactPersons ? (
                <>
                  {entity.get('field_contact_person', Immutable.List()).map((contactPerson) => (
                    <>
                      <Node
                        viewMode="teaser"
                        key={contactPerson.get('uuid')}
                        id={contactPerson.getIn(['entity', 'nid', 0, 'value'])}
                        entity={contactPerson.get('entity')}
                      />
                    </>
                  ))}
                </>
              ) : null}

              {partners ?
                entity.get('field_contact_person', Immutable.List()).size < 2 &&
                (
                  <>
                    {entity.get('field_organisation', Immutable.List()).map((partner) => (
                      <Node
                        viewMode="teaser"
                        key={partner.get('uuid')}
                        id={partner.getIn(['entity', 'nid', 0, 'value'])}
                        entity={partner.get('entity')}
                      />
                    ))}
                  </>
                ) : null}

            </div>
          </div>
        </div>
      </div>
    </Container >
  );


};

export default ParagraphContactInformation;
